import React from 'react';
import { GatsbyBrowser } from 'gatsby';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './src/styles/reset.scss';
import './src/styles/variables.scss';
import './src/styles/global.scss';
import './src/styles/toastify.scss';
import store from './src/redux/store';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element }) => {
    return (
        <Provider store={store}>
            {element}
            <ToastContainer className="ap-toastify" />
        </Provider>
    );
};

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({
    pathname,
    prevRouterProps,
    routerProps,
}) => {
    const prevPathname = prevRouterProps?.location.pathname;
    const preventScroll = routerProps.location.state?.preventScroll;
    return !(prevPathname === pathname && preventScroll);
};
